

<div style="display: flex; flex-direction: column; flex: 1 1 200px; max-width: 200px;">
    <slot />
</div>